"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedTransition = void 0;
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var theme_1 = require("../../../mantine-theme/src");
var get_transition_styles_1 = require("./get-transition-styles/get-transition-styles");
function GroupedTransition(_a) {
    var transitions = _a.transitions, mounted = _a.mounted, children = _a.children, themeOverride = _a.themeOverride;
    var theme = theme_1.useMantineTheme(themeOverride);
    var duration = Math.max.apply(Math, Object.keys(transitions).map(function (transition) { return transitions[transition].duration; }));
    return (react_1.default.createElement(react_transition_group_1.Transition, { in: mounted, timeout: duration, unmountOnExit: true, mountOnEnter: true, onEnter: function (node) { return node.offsetHeight; } }, function (transitionState) {
        var transitionsStyles = Object.keys(transitions).reduce(function (acc, transition) {
            acc[transition] = get_transition_styles_1.getTransitionStyles({
                duration: transitions[transition].duration,
                transition: transitions[transition].transition,
                timingFunction: transitions[transition].timingFunction || theme.transitionTimingFunction,
                state: transitionState,
            });
            return acc;
        }, {});
        return children(transitionsStyles);
    }));
}
exports.GroupedTransition = GroupedTransition;
GroupedTransition.displayName = '@mantine/core/GroupedTransition';
